import moment from 'moment';
import XLSX from 'xlsx';

export const extractContractId = (contracts, annee, trimestre) => {
    let listContracts = [];

    for (const contract of contracts) {
        listContracts.push({
            contrat_id: String(contract.contratId.contrat_id),
            num_version: String(contract.contratId.num_version),
            annee: annee,
            trimestre: trimestre
        });
    }

    return listContracts;
};

export const formatRmg = (data) => {
    if (data !== null && data !== 0) {
        return "RMG n°" + data;
    } else {
        return "Sans RMG";
    }
};

export const formatAmount = (num, precision, unite) => {
    if (precision !== undefined) {
        if (unite) {
            return Number(parseFloat(num).toFixed(precision)).toLocaleString() + " " + unite;
        }
        return Number(parseFloat(num).toFixed(precision)).toLocaleString();
    }

    return parseFloat(num).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, '$1 ') + ' €';
};

export const formatNumber = (num) => {
    return parseFloat(num).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, '$1 ');
};

export const formatCoeff = (coeff) => {
    return (parseFloat(coeff) * 100).toFixed(2) + ' %';
}

export const lpad = (e, padString, length) => {
    var str = e.toString();

    while (str.length < length) {
        str = padString + str;
    }

    return str;
}

export const getFormatFromType = (nomDoc) => {
    let extractExtensionFile = nomDoc.toLowerCase().split('.')[1];

    switch (extractExtensionFile) {
        case "jpg":
            return "image/jpeg";
        case "pdf":
            return "application/pdf";
        case "png":
            return "image/png";
    }
}

export const checkAssiette = (alert, assiette, redevance, type, seuil) => {
    let assietteIsValid = true;
    let errorMessage = "";

    // Contrôle des données de la redevance
    if (assiette.enseigne == null || assiette.activite == null || assiette.rubriques == null || assiette.typeRedevance == null) {
        assietteIsValid = false;
        errorMessage = "Merci de renseigner une enseigne, une activité et un type de redevance pour l'assiette en cours de création";
    }

    // Contrôle des données de l'assiette en fonction de la redevance sélectionnée
    switch (type) {
        case 'fixe':
            if (assietteIsValid && (redevance == null || redevance.dateTransfert == null || redevance.montant == null || redevance.coeffIndex == null ||
                redevance.indice == null)) {
                assietteIsValid = false;
                errorMessage = "Merci de renseigner une date de transfert, un montant, un coefficient d'indexation et un indice de redevance pour la création de cette redevance";
            }
            break;
        case 'fixeModulee':
            if (assietteIsValid && (redevance == null || redevance.dateTransfert == null || redevance.montant == null || redevance.coeffIndex == null ||
                redevance.indice == null || redevance.indicePalier == null)) {
                assietteIsValid = false;
                errorMessage = "Merci de renseigner une date de transfert, un montant, un coefficient d'indexation, un indice de redevance et un indice de palier pour la création de cette redevance";
            }
            break;
        case 'variablePalier':
            if (assietteIsValid && (redevance == null || redevance.dateTransfert == null || redevance.coeffIndex == null || redevance.indicePalier == null ||
                redevance.modeActualisation == null)) {
                assietteIsValid = false;
                errorMessage = "Merci de renseigner une date de transfert, un coefficient d'indexation, un indice de redevance et un mode d'actualisation pour la création de cette redevance";
            }
            break;
        case 'variableSeuil':
            if (assietteIsValid && (redevance == null || redevance.dateTransfert == null || redevance.coeffIndex == null || redevance.indice == null ||
                redevance.modeActualisation == null)) {
                assietteIsValid = false;
                errorMessage = "Merci de renseigner une date de transfert, un coefficient d'indexation, un indice de redevance ainsi qu'un mode d'actualisation pour la création de cette redevance";
            } else if (assietteIsValid && (seuil == null || seuil.value === '' || seuil.taux === '')) {
                assietteIsValid = false;
                errorMessage = "Merci de renseigner un seuil de déclenchement ainsi qu'un taux applicable à ce seuil pour la création de cette redevance";
            }
            break;
        case 'variableSeuilAutreAssiette':
            if (assietteIsValid && (redevance == null || redevance.dateTransfert == null || redevance.coeffIndex == null || redevance.indice == null ||
                redevance.modeActualisation == null || redevance.numAssietteRattachement == null)) {
                assietteIsValid = false;
                errorMessage = "Merci de renseigner une date de transfert, un coefficient d'indexation, un indice de redevance, une assiette de rattachement ainsi qu'un mode d'actualisation pour la création de cette redevance";
            } else if (assietteIsValid && (seuil == null || seuil.value === '' || seuil.taux === '')) {
                assietteIsValid = false;
                errorMessage = "Merci de renseigner un seuil de déclenchement ainsi qu'un taux applicable à ce seuil pour la création de cette redevance";
            }
            break;
    }

    // Affichage du message d'erreur
    if (!assietteIsValid) {
        alert.removeAll();
        alert.error(errorMessage);
    }

    return assietteIsValid;
}

export const checkPaliers = (alert, paliers) => {
    let paliersIsValid = true;
    alert.removeAll();

    if (paliers) {
        paliers.forEach((palier, indice) => {
            if ((palier.minVal === '' || palier.maxVal === '' || palier.coeff === '') && paliersIsValid) {
                paliersIsValid = false;
                alert.removeAll();
                alert.error("Merci de renseigner l'ensemble des valeurs pour chaque palier présent");
            }
        });
    } else {
        paliersIsValid = false;
        alert.removeAll();
        alert.error("Merci de renseigner au moins un palier avant de continuer");
    }

    return paliersIsValid;
};

export const downloadExcel = (datas, filename) => {
    const newData = datas.map(row => {
        delete row.tableData
        return row
    })

    const workSheet = XLSX.utils.json_to_sheet(newData)
    const workBook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workBook, workSheet, "Feuil1")

    let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" })
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" })
    XLSX.writeFile(workBook, "Vision_Aire_Export_" + filename + "_" + moment().format("YYYY-MM-DD_HH-mm-ss") + ".xlsx")
}

export const transformDatas = (datas, dataValue, dataLabel) => {
    const formattedDatas = [];

    datas.map((d) => {
        formattedDatas.push({ value: d[dataValue], label: d[dataLabel] });
    });

    return formattedDatas;
};

export const logError = (alert, error) => {
    alert.removeAll();
    alert.error(`Erreur ${error?.response?.data?.status ? error?.response?.data?.status : '500'} : ${error?.response?.data?.message}` || "Une erreur est survenue lors de l'appel API, merci de contacter un administrateur");
}

export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber || isNaN(phoneNumber)) return `input must be a number was sent ${phoneNumber}`;
    if (typeof (phoneNumber) !== 'string') phoneNumber = phoneNumber.toString();
    if (phoneNumber.length === 10) {
        return phoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
    }
};
